/** A simple, friendly watering can (decorative scene prop). */
export function WateringCan({ className }) {
  return (
    <svg viewBox="0 0 140 120" className={className} aria-hidden focusable="false">
      {/* handle */}
      <path d="M58 56 C 58 24, 104 24, 104 56" fill="none" stroke="#3E8AD0" strokeWidth="9" strokeLinecap="round" />
      {/* body */}
      <path d="M48 52 L120 52 C124 52 126 56 124 60 L114 104 C112 110 108 112 100 112 L66 112 C58 112 54 110 52 104 L42 60 C40 56 44 52 48 52 Z" fill="#5FA8E6" />
      {/* body highlight */}
      <path d="M54 60 L116 60 L112 78 C100 84 70 84 58 78 Z" fill="#7CBCF2" opacity="0.7" />
      {/* spout */}
      <path d="M48 64 L14 40 L6 50 L40 78 Z" fill="#5FA8E6" />
      {/* rose / sprinkler head */}
      <ellipse cx="11" cy="44" rx="9" ry="7" fill="#3E8AD0" transform="rotate(-34 11 44)" />
      <circle cx="7" cy="42" r="1.4" fill="#A9D6FF" />
      <circle cx="12" cy="40" r="1.4" fill="#A9D6FF" />
      <circle cx="13" cy="47" r="1.4" fill="#A9D6FF" />
    </svg>
  );
}

export default WateringCan;
